import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'

import { FlexColumn } from 'Components/layout'
import { Tooltip } from 'Components/readonly'
import { AbsoluteAnchor, DisabledInfoIcon, InfoButton, Service, ServiceIcon, ServicePanel } from './startPageStyle'

import IconSDSManagement from './assets/ico-sdsm.svg'

const Wrapper = styled(FlexColumn)`
  height: 100%;
`

export default () => {
  const intl = useIntl()

  return (
    <Wrapper>
      <Service>
        <ServicePanel not_authorized>
          <Tooltip content={intl.formatMessage({ id: 'capabilities.not_authorized' })}>
            <InfoButton link label={<DisabledInfoIcon/>}/>
          </Tooltip>
          <AbsoluteAnchor>
            <ServiceIcon>
              <img src={IconSDSManagement} alt="SDS management"/>
            </ServiceIcon>
            <span className="service-type">SOFT</span>
            <h2>
              <FormattedMessage id="sds.module"/>
            </h2>
            <span className="service-author">by KemRisk</span>
          </AbsoluteAnchor>
        </ServicePanel>
      </Service>
    </Wrapper>
  )
}
